// extracted by mini-css-extract-plugin
export default {"HorizontalRule":"HorizontalRule_HorizontalRule__argHE","Container":"HorizontalRule_Container__ksU+o","Text":"HorizontalRule_Text__A4eMW"};